import Moment from 'moment-timezone';
import { VitalityLoadingState } from '@/utils/classes/VitalityLoadingState';
import { VitalityCategory } from '@/utils/classes/VitalityCategory';
import { LSK_HIDE_VH_CRITERION_SENSEI, LSK_HIDE_VH_WELCOME } from '@/utils/constants';
import { getRelativeRange } from '@/utils/vhub-utils';

const VLS = VitalityLoadingState;

// Initial value of criterion tables hints
// Should the criterion tables display the sensei hints or not
const showSenseiForCriterion = {};
VitalityCategory.all.forEach((category) => {
  category.criteria.forEach((criterion) => {
    const lsk = `${LSK_HIDE_VH_CRITERION_SENSEI}${criterion.key}`;
    showSenseiForCriterion[criterion.key] = !(window.localStorage.getItem(lsk) === 'true');
  });
});

// On first visit on the V-hub, users will be prompted with a welcome message
const showWelcomeMessage = !(window.localStorage.getItem(LSK_HIDE_VH_WELCOME) === 'true');

const initialRange = { start: Moment().startOf('month'), end: Moment().endOf('month') };
const initialRanges = [
  initialRange,
  getRelativeRange(initialRange, -1),
  getRelativeRange(initialRange, -2),
  getRelativeRange(initialRange, -3),
  getRelativeRange(initialRange, -4),
  getRelativeRange(initialRange, -5),
  getRelativeRange(initialRange, -6),
];


export default {
  // Should the fullscreen loading overlay be displayed
  displayFullscreenLoading: false,
  // Loading information per type of data. { problems: VLS.WORKING }
  loading: {},
  // Is the data processing being finalized
  finalizingLoading: VLS.FETCHING,
  // All data types as: { data_key: data } (eg: { problems: [], actions: [] })
  allData: {},
  // Clustered data per team. Keys are team ids and values are objects
  // eg: { '<team_id>': {
  //   problems: { problems: [] },
  //   actions: { actions: [] },
  //   gembaWalks: { completedGws: [], plannings: [] }
  // } }
  dataPerTeam: {},
  // Displayed period range (used for getters)
  ranges: initialRanges,

  // Teams can be grouped into set of teams to visualize the data of multiple teams
  teamGroups: [],
  // Did the current user customized his team groups
  usingDefaultTeamGroups: false,
  // Loading information per group { <group_id>: { editingName: true, editingTeams: false, loadingState: VLS } }
  loadingPerGroup: {},

  // Do the same calculation for the data from all the teams to calculate global vitality
  // As of v1.3.54, this is only used for category hints
  allTeamsObject: {},

  // Show/hide Sensei hints
  showSenseiForCriterion,

  // Show/hide welcome message
  showWelcomeMessage,
};
